import styled from "styled-components";

const Card = styled.div`

background:#20263A;

padding:24px;

border-radius:24px;

color:#F8FAFC;

`;

export default function NoticiasCard({

noticia

}){

if(!noticia){

return null;

}

return(

<Card>

<h2
style={{
    margin:0,
    color:"#F8FAFC"
}}
>
📰 Noticias de Yuta
</h2>

<h3
style={{
    marginTop:18,
    color:"#38BDF8"
}}
>
{noticia.titulo}
</h3>

<div
style={{
    color:"#CBD5E1",
    lineHeight:1.8
}}
dangerouslySetInnerHTML={{
    __html:noticia.html
}}
/>

</Card>

);

}

const SummaryCard = styled.div`
	width: 100%;
	max-width: 700px;

	max-height: 90vh;

	overflow-y: auto;

	scrollbar-width: none;

	padding: 2rem;

	border-radius: 34px;

	background:
		linear-gradient(
			145deg,
			rgba(255,255,255,0.08),
			rgba(255,255,255,0.03)
		);

	border:
		1px solid rgba(255,255,255,0.08);

	backdrop-filter: blur(18px);

	box-shadow:
		0 20px 80px rgba(0,0,0,.45);
`;
